import React, { type FC } from 'react';

import { Stack } from '@atlaskit/primitives/compiled';

import { expValEquals } from '@confluence/feature-experiments';

import {
	SpecificAccessDetails,
	type SpecificAccessDetailsProps,
} from './specificAccessDetails/SpecificAccessDetails.tsx';
import {
	PublicLinkDialogBody,
	type PublicLinkDialogBodyProps,
} from './publicLink/PublicLinkDialogBody.tsx';
import {
	ShareToSlackDialogBody,
	type ShareToSlackDialogBodyProps,
} from './shareToSlack/ShareToSlackDialogBody.tsx';
import {
	AccessRequestsDialogBody,
	type AccessRequestsDialogBodyProps,
} from './accessRequests/AccessRequestsDialogBody.tsx';

export type BodyProps = {
	specificAccessDetails?: SpecificAccessDetailsProps;
	publicLinkDialogBody?: PublicLinkDialogBodyProps;
	shareToSlackDialogBody?: ShareToSlackDialogBodyProps;
	accessRequestsDialogBody?: AccessRequestsDialogBodyProps;
	tabSelection?: number;
	// Alternative modes' bodies to go here, if we end up supporting any
};

const getSpecificAccessDetailsComponent = ({
	specificAccessDetails,
	isSpecificAccessTabSelected,
}) => {
	if (!specificAccessDetails) {
		return null;
	}

	if (expValEquals('persistence_specific_access_gate', 'cohort', 'experiment')) {
		return isSpecificAccessTabSelected ? (
			<SpecificAccessDetails {...specificAccessDetails} />
		) : null;
	} else {
		return <SpecificAccessDetails {...specificAccessDetails} />;
	}
};

export const Body: FC<BodyProps> = ({
	specificAccessDetails,
	publicLinkDialogBody,
	shareToSlackDialogBody,
	accessRequestsDialogBody,
	tabSelection,
}: BodyProps) => {
	const isSpecificAccessTabSelected = tabSelection === 0;
	const isRequestsDialogBodyTabSelected = tabSelection === 1;

	return (
		<Stack grow="fill">
			{getSpecificAccessDetailsComponent({ specificAccessDetails, isSpecificAccessTabSelected })}
			{publicLinkDialogBody && <PublicLinkDialogBody {...publicLinkDialogBody} />}
			{shareToSlackDialogBody && <ShareToSlackDialogBody {...shareToSlackDialogBody} />}
			{/* TODO: will add access request body in a future update  */}
			{isRequestsDialogBodyTabSelected &&
				expValEquals('persistence_specific_access_gate', 'cohort', 'experiment') &&
				'Request access body'}
			{accessRequestsDialogBody && <AccessRequestsDialogBody {...accessRequestsDialogBody} />}
			{/* TODO: different bodies, if we do end up supporting different modes */}
		</Stack>
	);
};
